module.exports = __webpack_public_path__ + "img/investing-dark.4d7bc05d.svg";